import React, {Component} from 'react';
import Validator from "../../utilities/Validator";

export default class InlineInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: ''
        };
        this.onChangeValue = this.onChangeValue.bind(this)
        this.onClickSave = this.onClickSave.bind(this)
    }

    componentDidMount() {
        this.setState({value: Boolean(this.props.val) ? this.props.val : ''})
    }

    onChangeValue(e) {
        this.setState({value: e.target.value})

    }

    onClickSave() {
        let obj = this.props.item;
        if (this.props.validateDouble) {

            let val = this.state.value.toString();

            if (val.indexOf(',') > -1) {
                val = val.replace(',', '.');
            }

            if (val.length > 0 && Validator.validateIntOrDouble(val)) {
                obj[this.props.itemvalue] = val
            }
        }
        else {

            if (this.state.value.length > 0 && Validator.validateInt(this.state.value, false)) {
                obj[this.props.itemvalue] = this.state.value;
            }
        }
       this.props.handleClickZapisz(obj)
    }

    render() {

        return (
            <div
                className={(Boolean(Validator.validateInt(this.state.value, false)) || Boolean(Validator.validateIntOrDouble(this.state.value)) || this.state.value==0) ? 'inlineInputComponent' : 'inlineInputComponent has-error'}>
                <input className={'form-control input-sm'} defaultValue={this.props.val} onChange={this.onChangeValue}/>
                <button className={'btn btn-primary btn-sm'} title={'Zapisz'} onClick={this.onClickSave}><i className={'fa fa-check'}></i></button>
                <button className={'btn btn-default btn-sm'} title={'Anuluj'} onClick={() => this.props.handleAnuluj()}><i
                    className={'fa fa-times'}></i></button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/shared/inlineFormsControl/InlineInput.js